import React from 'react';

const FooterIndustrial: React.FC = () => {
  return (
    <footer className="footer-industrial">
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Mapa de Google Maps */}
        <div style={{
          marginBottom: '48px'
        }}>
          <h3 style={{
            fontFamily: 'var(--industrial-font-secondary)',
            fontSize: '1rem',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            color: 'var(--industrial-white)',
            marginBottom: '24px',
            textAlign: 'center'
          }}>
            📍 ENCUÉNTRANOS EN NUESTRAS SEDES
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '24px'
          }}>
            {/* Mapa Medellín */}
            <div style={{
              borderRadius: '8px',
              overflow: 'hidden',
              border: '2px solid var(--industrial-border)',
              backgroundColor: 'var(--industrial-dark-bg)'
            }}>
              <div style={{
                padding: '12px',
                backgroundColor: 'var(--industrial-darker-bg)',
                borderBottom: '1px solid var(--industrial-border)'
              }}>
                <div style={{
                  fontFamily: 'var(--industrial-font-secondary)',
                  fontSize: '0.875rem',
                  color: 'var(--industrial-primary)',
                  fontWeight: '600',
                  marginBottom: '4px'
                }}>
                  SEDE MEDELLÍN
                </div>
                <div style={{
                  fontSize: '0.75rem',
                  color: 'var(--industrial-light-metallic)'
                }}>
                  Calle 13 sur #51C-54
                </div>
              </div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.0859634691817!2d-75.61547842503777!3d6.250867093752908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e4428356e1e1e1d%3A0x1e1e1e1e1e1e1e1e!2sCl.%2013%20Sur%20%2351c-54%2C%20Medell%C3%ADn%2C%20Antioquia!5e0!3m2!1ses!2sco!4v1234567890"
                width="100%"
                height="300"
                style={{ border: 0, display: 'block' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Sede Medellín - Calle 13 sur #51C-54"
              ></iframe>
            </div>

            {/* Mapa Bogotá */}
            <div style={{
              borderRadius: '8px',
              overflow: 'hidden',
              border: '2px solid var(--industrial-border)',
              backgroundColor: 'var(--industrial-dark-bg)'
            }}>
              <div style={{
                padding: '12px',
                backgroundColor: 'var(--industrial-darker-bg)',
                borderBottom: '1px solid var(--industrial-border)'
              }}>
                <div style={{
                  fontFamily: 'var(--industrial-font-secondary)',
                  fontSize: '0.875rem',
                  color: 'var(--industrial-primary)',
                  fontWeight: '600',
                  marginBottom: '4px'
                }}>
                  SEDE BOGOTÁ
                </div>
                <div style={{
                  fontSize: '0.75rem',
                  color: 'var(--industrial-light-metallic)'
                }}>
                  Cra 58b bis # 131A 51
                </div>
              </div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.2855555555555!2d-74.11111111111111!3d4.7111111111111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9b1b1b1b1b1b%3A0x1b1b1b1b1b1b1b1b!2sCra.%2058b%20Bis%20%23131a-51%2C%20Bogot%C3%A1!5e0!3m2!1ses!2sco!4v1234567890"
                width="100%"
                height="300"
                style={{ border: 0, display: 'block' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Sede Bogotá - Cra 58b bis # 131A 51"
              ></iframe>
            </div>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '48px', marginBottom: '48px' }}>
          <div>
            <div style={{
              fontFamily: 'var(--industrial-font-heading)',
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: 'var(--industrial-primary)',
              marginBottom: '16px'
            }}>
              JUNISAMA INDUSTRIAL
            </div>
            <p style={{
              color: 'var(--industrial-light-metallic)',
              lineHeight: '1.6',
              marginBottom: '24px'
            }}>
              Infraestructura sanitaria de grado industrial para eventos de gran escala.
              Cumplimiento normativo y operación 24/7 garantizada.
            </p>
            <div className="footer-certification" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              fontSize: '0.875rem',
              color: 'var(--industrial-primary)',
              fontFamily: 'var(--industrial-font-secondary)',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              <span>◈</span>
              <span>ISO14001 CERTIFICADO</span>
            </div>
          </div>
          
          <div>
            <h4 style={{
              fontFamily: 'var(--industrial-font-secondary)',
              fontSize: '0.875rem',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              color: 'var(--industrial-white)',
              marginBottom: '16px'
            }}>
              SERVICIOS TÉCNICOS
            </h4>
            <ul style={{ listStyle: 'none', display: 'grid', gap: '8px' }}>
              {['Alquiler Industrial', 'Mantenimiento 24/7', 'Operarios Certificados', 'Insumos Eco-friendly'].map((service, index) => (
                <li key={index} style={{
                  color: 'var(--industrial-light-metallic)',
                  fontSize: '0.875rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <span style={{ color: 'var(--industrial-primary)' }}>▸</span>
                  {service}
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 style={{
              fontFamily: 'var(--industrial-font-secondary)',
              fontSize: '0.875rem',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              color: 'var(--industrial-white)',
              marginBottom: '16px'
            }}>
              CONTACTO 24/7
            </h4>
            <div style={{ display: 'grid', gap: '12px' }}>
              <div style={{ fontSize: '0.875rem' }}>
                📞 +57 350 708 9584
              </div>
              <div style={{ fontSize: '0.875rem' }}>
                📧 soporte@junisama.com
              </div>
              <a
                href="https://login.microsoftonline.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontSize: '0.875rem',
                  color: 'var(--industrial-primary)',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = 'var(--industrial-accent)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = 'var(--industrial-primary)';
                }}
              >
                <span>✉️</span>
                <span>Correo Corporativo</span>
              </a>
              <div style={{
                fontSize: '0.875rem',
                marginTop: '8px',
                paddingTop: '12px',
                borderTop: '1px solid var(--industrial-border)'
              }}>
                <div style={{
                  color: 'var(--industrial-primary)',
                  fontWeight: '600',
                  marginBottom: '8px'
                }}>
                  📍 NUESTRAS SEDES
                </div>
                <div style={{
                  color: 'var(--industrial-light-metallic)',
                  marginBottom: '6px'
                }}>
                  Medellín: Calle 13 sur #51C-54
                </div>
                <div style={{
                  color: 'var(--industrial-light-metallic)'
                }}>
                  Bogotá: Cra 58b bis # 131A 51
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 style={{
              fontFamily: 'var(--industrial-font-secondary)',
              fontSize: '0.875rem',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              color: 'var(--industrial-white)',
              marginBottom: '16px'
            }}>
              SÍGUENOS
            </h4>
            <div className="footer-social-icons" style={{
              display: 'flex',
              gap: '16px',
              flexWrap: 'wrap'
            }}>
              <a
                href="https://www.instagram.com/junisama_inversiones?utm_source=ig_web_button_share_sheet&igsh=MWVxY296MzMwd3AxYg=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Síguenos en Instagram"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '44px',
                  height: '44px',
                  borderRadius: '8px',
                  backgroundColor: 'var(--industrial-darker-bg)',
                  border: '1px solid var(--industrial-border)',
                  color: 'var(--industrial-light-metallic)',
                  transition: 'all 0.3s ease',
                  textDecoration: 'none'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)';
                  e.currentTarget.style.borderColor = '#dc2743';
                  e.currentTarget.style.color = '#FFFFFF';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'var(--industrial-darker-bg)';
                  e.currentTarget.style.borderColor = 'var(--industrial-border)';
                  e.currentTarget.style.color = 'var(--industrial-light-metallic)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>

              <a
                href="https://www.linkedin.com/company/inversiones-junisama-s-a-s/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Síguenos en LinkedIn"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '44px',
                  height: '44px',
                  borderRadius: '8px',
                  backgroundColor: 'var(--industrial-darker-bg)',
                  border: '1px solid var(--industrial-border)',
                  color: 'var(--industrial-light-metallic)',
                  transition: 'all 0.3s ease',
                  textDecoration: 'none'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#0077B5';
                  e.currentTarget.style.borderColor = '#0077B5';
                  e.currentTarget.style.color = '#FFFFFF';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--industrial-darker-bg)';
                  e.currentTarget.style.borderColor = 'var(--industrial-border)';
                  e.currentTarget.style.color = 'var(--industrial-light-metallic)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>

            <div style={{
              marginTop: '16px',
              paddingTop: '16px',
              borderTop: '1px solid var(--industrial-border)',
              fontSize: '0.75rem',
              color: 'var(--industrial-light-metallic)',
              lineHeight: '1.4'
            }}>
              Síguenos en nuestras redes sociales para estar al día con nuestras novedades y promociones.
            </div>
          </div>
        </div>
        
        <div style={{
          borderTop: '1px solid var(--industrial-border)',
          paddingTop: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '0.875rem',
        }}>
          <div>
            © 2024 JUNISAMA INVERSIONES S.A.S - Todos los derechos reservados
          </div>
          <div style={{
            fontFamily: 'var(--industrial-font-secondary)',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            INDUSTRIAL GRADE SOLUTIONS
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterIndustrial;